import './App.css';
import Projects from './Projects';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header';
import ResumeCard from './Resume';
import ModelBackground from './ModelBackground';
import EgfrInfo from './EgfrInfo';

function App() {
  return (
    <>
      <ModelBackground />
      <Router>
        <div className="app-shell">
          <Header />
          <Routes>
            <Route path="/" element={<Projects />} />
            <Route path="/resume" element={<ResumeCard />} />
          </Routes>
        </div>
      </Router>
      <EgfrInfo />
    </>
  );
}

export default App;
